export const userResourceBasePath = '/v1/users';
